
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const AcceptableUseSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Acceptable Use Policy</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>You agree not to use the Service to:</p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>Violate any applicable laws or regulations</li>
          <li>Infringe on intellectual property rights</li>
          <li>Transmit harmful or malicious code</li>
          <li>Attempt to gain unauthorized access to our systems</li>
          <li>Use the service for any commercial purpose without permission</li>
          <li>Interfere with the proper functioning of the service</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);

export const DataPrivacySection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Data and Privacy</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>
          Your privacy is important to us. Our data practices are governed by our Privacy Policy, 
          which is incorporated into these Terms by reference. Key points include:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>We collect only necessary data to provide our services</li>
          <li>We do not sell your personal information to third parties</li>
          <li>You have the right to request deletion of your data</li>
          <li>We implement appropriate security measures to protect your data</li>
        </ul>
        <p className="mt-4">
          For complete details, please review our{' '}
          <a href="/privacy" className="text-blue-600 hover:underline">Privacy Policy</a>.
        </p>
      </div>
    </CardContent>
  </Card>
);

export const ServiceAvailabilitySection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Service Availability</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>
          We strive to maintain high service availability, but we do not guarantee uninterrupted access. 
          The Service may be temporarily unavailable due to:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>Scheduled maintenance</li>
          <li>Emergency repairs</li>
          <li>Third-party service dependencies</li>
          <li>Force majeure events</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);
